import { PacketIn } from "./PacketIn.js";
import { InboundPacketType } from "./InboundPacketType.js";
import { readJsonString, readNullableJsonDict } from "../../../../util/json.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";
import { ErrorType } from "../../error/ErrorType.js";
import { ClientError } from "../../error/ClientError.js";


export class PacketInError extends PacketIn {
    public error: ClientError | null = null;

    constructor() {
        super(InboundPacketType.ERROR);
    }

    getError(): ClientError {
        if (this.error === null)
            throw new Error("Packet has not been read yet");
        return this.error;
    }

    override readContents(
        _context: MessageIOContext,
        json: Record<string, any>,
    ): void {
        const type = ErrorType.getByIDOrUnknown(readJsonString(json, "error_type"));
        const message = readJsonString(json, "message");
        const data = readNullableJsonDict(json, "data");
        this.error = new ClientError(type, message, (data !== null ? data : undefined));
    }
}
